export default __webpack_public_path__ + "assets/improve-customer-value.d5572354.svg";